export default {
  obraID: {
    value: null,
    options: [],
    required: false,
    state: null,
    code: null
  },
  responsavelID: {
    value: null,
    options: [],
    required: false,
    state: null,
    code: null
  },
  favorecidoID: {
    value: null,
    options: [],
    required: false,
    state: null,
    code: null
  },
  secaoRH: {
    value: null,
    maxlength: '20',
    required: false,
    state: null
  },
  secaoRHID: {
    value: null,
    options: [],
    required: false,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/finance/expenses/miscellaneous/add/add-form.js